import { Link } from 'react-router-dom';
import BrandIcon from './BrandIcon';

interface FooterLink {
  label: string;
  href: string;
  route?: boolean;
}

interface FooterColumn {
  title: string;
  links: FooterLink[];
}

const COLUMNS: FooterColumn[] = [
  {
    title: 'Product',
    links: [
      { label: 'Features', href: '#features' },
      { label: 'How It Works', href: '#how-it-works' },
      { label: 'API Docs', href: '/api-docs', route: true },
      { label: 'Status', href: '/status', route: true },
    ],
  },
  {
    title: 'Company',
    links: [
      { label: 'Blog', href: '/blog', route: true },
      { label: 'Contact', href: '/contact', route: true },
    ],
  },
  {
    title: 'Legal',
    links: [
      { label: 'Privacy', href: '/privacy', route: true },
      { label: 'Terms', href: '/terms', route: true },
    ],
  },
];

export default function Footer() {
  return (
    <footer className="bg-navy-950 py-10 sm:py-12 px-4 sm:px-6 border-t border-navy-800/50">
      <div className="max-w-6xl mx-auto">
        <div className="grid grid-cols-2 md:grid-cols-4 gap-8 mb-10">
          <div>
            <Link to="/" className="font-mono text-bone-white tracking-widest text-sm font-medium">
              BONESPAY
            </Link>
            <p className="mt-3 font-sans text-xs text-bone-white/40 leading-relaxed">
                One Processor to Rule Them All.
            </p>
            <a
              href="https://github.com/bonesrnd/bonespay"
              target="_blank"
              rel="noopener noreferrer"
              className="mt-4 inline-flex items-center gap-2 text-bone-white/30 hover:text-bone-white/70 transition-colors"
              aria-label="BonesPay on GitHub"
            >
              <span className="[&_svg]:w-5 [&_svg]:h-5 brightness-0 invert opacity-60">
                <BrandIcon name="github" size={20} />
              </span>
              <span className="font-mono text-[10px] uppercase tracking-widest">GitHub</span>
            </a>
          </div>

          {COLUMNS.map((col) => (
            <div key={col.title}>
              <h4 className="font-mono text-[10px] text-bone-white/50 uppercase tracking-widest mb-3">
                {col.title}
              </h4>
              <ul className="space-y-2">
                {col.links.map((link) => (
                  <li key={link.label}>
                    {link.route ? (
                      <Link
                        to={link.href}
                        className="font-sans text-xs text-bone-white/40 hover:text-bone-white transition-colors"
                      >
                        {link.label}
                      </Link>
                    ) : (
                      <a
                        href={link.href}
                        className="font-sans text-xs text-bone-white/40 hover:text-bone-white transition-colors"
                      >
                        {link.label}
                      </a>
                    )}
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>

        <div className="border-t border-navy-800/50 pt-6 flex flex-col sm:flex-row items-start sm:items-center justify-between gap-4">
          <div className="flex items-center gap-4">
            <img
              src="/logobonesrnd.jpeg"
              alt="Bones R&D"
              className="h-10 w-auto rounded"
            />
            <div>
              <p className="font-mono text-[10px] text-bone-white/30 uppercase tracking-wider">
                &copy; {new Date().getFullYear()} BonesPay &mdash; A BONES R&amp;D Project. All rights reserved.
              </p>
              <p className="font-mono text-[10px] text-bone-white/20 leading-relaxed mt-1">
                The blockchain never forgets.
              </p>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
}
